import React, { Component } from "react";
import { Route, Switch, Router, Redirect } from "react-router-dom";

import { ThemeProvider, StyledEngineProvider, createTheme } from "@mui/material/styles";
// import { IntlProvider } from "react-intl";

import "./App.css";
import "./css/Home.css";
import "./css/Nav.css";
import "./css/Admin.css";
import "./css/Login.css";
import "./css/Page.css";
import "./css/Profile.css";
import "./css/Table.css";

import HomePage from "./components/HomePage";


import RequireAuth from "./components/HOC/RequireAuth";
import RequireAdmin from "./components/HOC/RequireAdmin";
import NoAuth from "./components/HOC/NoAuth";
import history from './history/history';
import Budget from "./components/Stats/Budget";
import Stats from "./components/Stats/Stats";
import UserSpendingForm from "./components/UserView/UserSpendings/UserSpendingForm";
import UserSpendingsList from "./components/UserView/UserSpendings/UserSpendingsList";
import AdminDashboard from "./components/Admin/AdminDashboard";
import LoginPage from "./components/LoginPage";

import SessionSwitchOverlay from "./components/common/SessionSwitchOverlay";
import Profile from "./components/UserView/Profile";
import HomePageEmployee from "./components/HomePageEmployee";
import RequireEmployee from "./components/HOC/RequireEmployee";

import RequireAuthEmployee from "./components/HOC/RequireAuthEmployee";
import UserSalaryList from "./components/UserView/UserSalaryList";
import UserTimeSheet from "./components/UserView/TimeSheetUser";
import UserDemands from "./components/UserView/UserDemands";
// import FicheStock from "./components/Admin/FicheStock";

import { teal } from '@mui/material/colors';
import EquipementInfoSingle from "./components/Admin/Equipements/EquipementInfoSingle";
import UserEquipements from "./components/UserView/UserEquipements";
import ResetPwdPage, { ResetPwdRequestPage } from "./components/Pages/ResetPwdPage";
import EmailConfirmationPage from "./components/Pages/EmailConfirmationPage";
// import TestPage from "./components/TestPage";
export const VERSION_APP = "v1.2.4";

class App extends Component {
	state = { }


	render() {
		// const theme = createTheme(adaptV4Theme({
		const theme = createTheme({
			palette: {
				// mode:'dark',
				// primary: {
				// 	main: "#ffd54f"
				// },
				primary: teal,
				secondary: {
					main: "#f1b817"
					// main: "#ffd54f"
				},
				// inherit: {
				// 	main: "gray"
				// },
				// error: {
				// 	main: red[300]
				// }
			},
			typography: {
				fontSize: 15,
				fontWeight: 500,
			},
			MuiPaper: {
				styleOverrides: {
				  root: {
					backgroundColor: "grey"
				  }
				}
			  }
		});

		return (
            <StyledEngineProvider injectFirst>
				{/* <IntlProvider locale={lang} messages={messages[lang]}>
				</IntlProvider> */}
                <ThemeProvider theme={theme}>
                    <SessionSwitchOverlay />
					<Router 
						onUpdate={() => window.scrollTo(0, 0)}  
						history={history} 
						{...this.state} 
					>
						
						<Switch>
							<Route exact path="/" component={RequireAuth(HomePage)} />
							<Route exact path="/employee" component={RequireEmployee(HomePageEmployee)} />
							{/* <Route exact path="/employee/profile" component={RequireEmployee(Profile)} /> */}
							<Route exact path="/salaries" component={RequireAuthEmployee(UserSalaryList)} />
							<Route exact path="/planning" component={RequireAuthEmployee(UserTimeSheet)} />
							<Route exact path="/demands" component={RequireAuthEmployee(UserDemands)} />
							<Route exact path="/immos" component={RequireAuth(UserEquipements)} />
							<Route exact path="/budget" component={RequireAuth(Budget)} />
							<Route exact path="/profile" component={RequireAuth(Profile)} />
							{/* <Route exact path="/society" component={RequireAdmin(Society)} /> */}
							<Route exact path="/spendings" component={RequireAuth(UserSpendingsList)} />
							<Route exact path="/spendings/new" component={RequireAuth(UserSpendingForm)} />
							<Route exact path="/stats" component={RequireAuth(Stats)} />
							{/* <Route exact path="/admin/:page" component={AdminDashboard} /> */}
							{/* <Route exact path="/stock" component={RequireAuth(FicheStock)}/> */}
							{/* <Route path="/admin/dashboard" component={RequireAdmin(AdminDashboard)}/> */}
							<Route path="/admin/:page" component={RequireAdmin(AdminDashboard)}/>
							<Route path="/admin" component={RequireAdmin(AdminDashboard)}/>
							<Route exact path="/equipement/:id" component={EquipementInfoSingle}/>
							<Route exact path="/feature-request" render={() => <Redirect to="/admin/feature_request" />} />
							<Route exact path="/login" component={NoAuth(LoginPage)}/>
							<Route exact path="/resetpwd" component={NoAuth(ResetPwdPage)}/>
							<Route exact path="/request-resetpwd" component={NoAuth(ResetPwdRequestPage)}/>
							{/* COMPTA-173: landing page for the link sent in the confirmation email */}
							<Route exact path="/email-confirmation" component={NoAuth(EmailConfirmationPage)}/>
							{/* <Route exact path="/test" component={TestPage}/> */}

							<Route render={ ()=> <Redirect to={{pathname: "/login"}} /> } />

						</Switch>
					</Router>
				</ThemeProvider>
            </StyledEngineProvider>
        );
	}
}


export default App;
